import { Component, ViewChild } from '@angular/core';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'app-base-overlay-panel',
  templateUrl: './overlay-panel.component.html',
  styleUrls: ['./overlay-panel.component.scss'],
  standalone: true,
  imports: [OverlayPanelModule],
})
export class BaseOverlayPanelComponent {
  @ViewChild('menu') panel?: OverlayPanel;
  constructor() {}
  togglePanel(): void {
    this.panel?.toggle(event);
  }
}
